export default {
  projectsPage: {
    kicker: "Сообщество",
    title: "Проекты",
    subtitle:
      "Создавайте исследовательские и творческие проекты, получайте оценки сообщества и поддержку экспертов РГБ.",
    propose: "Предложить проект",
    createTitle: "Новый проект",
    editTitle: "Редактирование проекта",
    open: "Открыть",
    edit: "Редактировать",
    delete: "Удалить",
    submit: "Отправить на модерацию",
    complete: "Завершить",
    save: "Сохранить",
    saving: "Сохраняем...",
    loadMore: "Показать ещё",
    goToPortal: "Перейти в портал проектов",
    authRequired: "Для действий с проектом нужно войти в аккаунт",
    requiredFields: "Заполните обязательные поля",
    relevanceMinLength: "Поле «Актуальность» должно содержать не менее 10 символов",
    neededResourcesRequired: "Выберите хотя бы один необходимый ресурс",
    participationGoalRequired: "Выберите хотя бы одну цель участия",
    classifiersRequired: "Выберите тип мышления, стадию зрелости, направление и правовой статус",
    consentsRequired: "Для отправки проекта нужно отметить все согласия",
    coverImageUrlRequired: "Загрузите обложку",
    presentationFileUrlsRequired: "Загрузите хотя бы один файл презентации",
    loadError: "Не удалось загрузить проекты. Попробуйте позже.",
    loadMoreError: "Не удалось подгрузить ещё проекты.",
    saveError: "Не удалось сохранить проект",
    submitModerationServerRejected:
      "Сервер отклонил отправку на модерацию. Проект сохранён как черновик — попробуйте отправить снова из списка «Мои проекты» позже или обратитесь в поддержку, если ошибка повторяется.",
    deleteError: "Не удалось удалить проект",
    workflowError: "Не удалось выполнить действие по проекту",
    detailLoadError: "Не удалось загрузить проект",
    statusAll: "Все",
    sortNewest: "Сначала новые",
    sortOldest: "Сначала старые",
    sortTitleAsc: "По названию (А→Я)",
    sortTitleDesc: "По названию (Я→А)",
    empty: "Проекты не найдены",
    emptyTitle: "Ничего не найдено",
    emptyDescription: "Попробуйте изменить фильтры или создайте новый проект.",
    activeFilters: "Активные фильтры:",
    resetFilters: "Сбросить",
    resetFiltersAria: "Сбросить поиск, фильтры по статусу и сортировку к значениям по умолчанию",
    searchFilter: "Поиск: «{{query}}»",
    filterGroups: {
      all: "Все",
      drafts: "Черновики",
      review: "На проверке",
      evaluation: "Оценка",
      team: "Команда",
      completed: "Завершены",
      rejected: "Отклонены",
    },
    export: {
      title: "Экспорт в Excel",
      toolbarButton: "Экспорт в Excel",
      toolbarAria: "Открыть настройки экспорта проектов в Excel",
      close: "Закрыть",
      cancel: "Отмена",
      download: "Скачать",
      loadingCatalog: "Загружаем поля для экспорта…",
      catalogLoadError: "Не удалось загрузить список полей. Попробуйте снова.",
      downloadError: "Не удалось скачать файл. Попробуйте снова.",
      noProjectFieldsSelected: "Выберите хотя бы одно поле проекта.",
      sheetsTitle: "Листы",
      sheetProjects: "Проекты",
      sheetTeam: "Команда",
      projectFieldsTitle: "Поля проекта",
      teamFieldsTitle: "Поля команды",
      selectAll: "Выбрать все",
      clearAll: "Снять все",
      ungrouped: "Прочее",
      multiStatusFilterHint:
        "Фильтр по группе статусов не передаётся на сервер. Будут экспортированы все проекты по поисковому запросу.",
      tooManyRows: "Слишком много проектов для экспорта (максимум 5000). Уточните фильтры.",
    },
    projectCount_one: "{{count}} проект",
    projectCount_few: "{{count}} проекта",
    projectCount_many: "{{count}} проектов",
    projectCount_other: "{{count}} проектов",
    notFound: "Проект не найден",
    back: "Назад",
    backToList: "К списку проектов",
    searchLabel: "Поиск по проектам",
    searchPlaceholder: "Поиск по названию или описанию…",
    confirmDeleteTitle: "Удалить проект?",
    confirmDelete: "Удалить проект?",
    rejectionReason: "Причина отклонения",
    fields: {
      title: "Название",
      shortDescription: "Краткое описание",
      mainProblem: "Основная проблема",
      relevance: "Актуальность",
      maturityStage: "Стадия зрелости",
      legalStatus: "Правовой статус",
      direction: "Направление",
      thinkingType: "Тип мышления",
      participationGoal: "Цель участия",
      neededResources: "Необходимые ресурсы",
      currentRealizationStatus: "Текущий статус реализации",
      existingPartners: "Партнёры",
      mediaMentions: "Упоминания в СМИ",
      expertRecommendations: "Рекомендации экспертов",
      coverImage: "Обложка",
      presentationFiles: "Файлы презентации",
      finalScoreInitial: "Итоговый балл (основной раунд)",
      finalScoreAdditional: "Итоговый балл (доп. раунд)",
      teamMembers: "Команда",
      status: "Статус",
      creationTime: "Создан",
    },
    stages: {
      moderation: "Модерация",
      evaluation: "Оценка",
      team: "Команда",
    },
    detailSections: {
      about: "О проекте",
      realization: "Реализация",
      resources: "Ресурсы и партнёры",
    },
    form: {
      title: "Название проекта",
      titleHint: "Не более 60 символов",
      shortDescription: "Короткое описание",
      shortDescriptionHint: "Не более 200 символов",
      mainProblem: "Ключевая проблема",
      mainProblemHint: "Не более 512 символов",
      relevance: "Актуальность",
      relevanceHint: "От 10 до 1000 символов",
      currentRealizationStatus: "Текущий статус реализации",
      currentRealizationStatusHint: "Не более 2000 символов",
      existingPartners: "Существующие партнёры",
      existingPartnersHint: "Не более 1000 символов",
      mediaMentions: "Упоминания в СМИ",
      mediaMentionsHint: "Не более 1000 символов",
      expertRecommendations: "Рекомендации экспертов",
      expertRecommendationsHint: "Не более 1000 символов",
      coverImageUrl: "Обложка",
      coverImageUploadHint: "Допустимые форматы: JPG, PNG, JFIF. Не более 10 МБ.",
      coverImageInvalidFormat: "Выберите файл в формате JPG, PNG или JFIF.",
      presentationFileUrls: "Файлы презентации (до 2)",
      presentationFileCount: "Прикреплено файлов: {{current}} из {{max}}",
      presentationAddAnother: "Добавить ещё один файл",
      presentationUploadHint:
        "До двух файлов: только PDF или изображения (JPG, PNG, JFIF). Нужен хотя бы один файл. Не более {{maxMb}} МБ на каждый файл. Слайды PowerPoint сохраните как PDF.",
      presentationInvalidFormat: "Допустимы только PDF, JPG, PNG и JFIF.",
      presentationFileTooLarge: "Файл больше {{maxMb}} МБ. Выберите файл меньшего размера.",
      selectPlaceholder: "Выберите…",
      thinkingType: "Тип мышления",
      participationGoal: "Цель участия",
      maturityStage: "Стадия зрелости проекта",
      direction: "Направление проекта",
      legalStatus: "Правовой статус",
      neededResources: "Необходимые ресурсы",
      consentPersonalData: "Согласие на обработку персональных данных",
      consentIpRights: "Согласие на передачу прав ИС",
      consentDocumentsReadiness: "Подтверждаю готовность документов",
      consentPhotoVideo: "Согласие на фото/видео",
      consentDocumentLink: "Открыть документ",
      submitNow: "Сразу отправить на модерацию",
      saveDraft: "Сохранить черновик",
      submitForModeration: "Отправить на модерацию",
      nextStep: "Далее",
      prevStep: "Назад",
      progress: "{{completed}} из {{total}} обязательных пунктов заполнено",
      steps: {
        idea: "Идея",
        status: "Статус",
        resources: "Ресурсы",
        submit: "Отправка",
      },
    },
    portal: {
      pageTitle: "Портал проектов",
      pageSubtitle: "Управление проектами акселератора",
      sidebarAria: "Навигация портала проектов",
      navAria: "Разделы портала",
      navWorkGroups: {
        moderation: "Модерация и рейтинг",
        evaluation: "Экспертная оценка",
        criteria: "Критерии оценки",
        team: "Команды проектов",
      },
      mySubtitle: "Ваши заявки и проекты, в команду которых вы вступили после принятия приглашения.",
      registrySubtitle: "Каталог проектов с фильтрами и карточками внутри личного кабинета.",
      nav: {
        newApplication: "Новый проект",
      },
      my: {
        emptyCta: "Создать новый проект",
        ownedSectionTitle: "Мои заявки",
        ownedSectionHint: "Черновики, заявки на доработке и проекты, которые вы создали и отправили.",
        ownedSectionEmpty: "У вас пока нет собственных заявок на проект.",
        teamSectionTitle: "Проекты, где я в команде",
        teamSectionHint: "Проекты, в которые вас пригласили и вы приняли приглашение.",
        teamSectionEmpty: "Пока нет проектов, в команду которых вы вступили.",
        teamMemberBadge: "Участник команды",
        teamRoleLabel: "Роль: {{role}}",
        goToMyProjects: "Перейти в «Мои проекты»",
      },
      tabs: {
        overview: "Обзор",
        myProjects: "Мои проекты",
        registry: "Реестр проектов",
        moderation: "Модерация",
        evaluation: "Оценка",
        criteria: "Критерии",
        scoreboard: "Рейтинг",
        evaluationSummaryByExperts: "Оценка по экспертам",
        evaluationSummaryByProjects: "Оценка по проектам",
        teamInvitations: "Приглашения",
        team: "Команды",
      },
      overview: {
        title: "Обзор проектов",
        subtitle: "Быстрый доступ к вашим проектам и рабочим очередям по ролям.",
        retry: "Повторить",
        statsLoading: "Загружаем статистику проектов",
        statsLoadError: "Не удалось загрузить сводку проектов",
        goToSection: "Перейти в раздел",
        myHint: "Следите за своими черновиками, доработками и отправленными проектами.",
        myDraftsAndReturns_one: "{{count}} черновик или доработка",
        myDraftsAndReturns_few: "{{count}} черновика или доработки",
        myDraftsAndReturns_many: "{{count}} черновиков или доработок",
        myDraftsAndReturns_other: "{{count}} черновика или доработки",
        moderationHint: "Проекты, ожидающие модерации отбора.",
        evaluationHint: "Проекты, готовые к основной или дополнительной экспертной оценке.",
        teamHint: "Проекты на этапах модерации, оценки и формирования команды, доступные для управления составом.",
      },
      intro: {
        title: "Подать проект",
        subtitle: "Заполните карточку проекта, сохраните черновик или сразу отправьте заявку на модерацию.",
        hint: "Конструктор откроется в разделе «Мои проекты», чтобы черновики и отправленные заявки были рядом.",
        howTitle: "Как устроена подача",
        step1Title: "Опишите идею",
        step1Desc: "Добавьте название, проблему, актуальность и краткое описание проекта.",
        step2Title: "Уточните статус",
        step2Desc: "Выберите направление, зрелость, правовой статус и цель участия.",
        step3Title: "Отправьте заявку",
        step3Desc: "Укажите необходимые ресурсы, приложите ссылки и подтвердите согласия.",
        startCta: "Начать заполнение",
        backToList: "К моим проектам",
      },
      metrics: {
        drafts: "Мои черновики",
        moderation: "На модерации",
        evaluation: "Ожидают оценки",
        team: "Формирование команды",
      },
    },
    moderation: {
      stageModeration: "Модерация",
      stageEvaluation: "Оценка",
      stageTeam: "Команда",
      approveModeration: "Одобрить и перевести на оценку",
      returnForRevision: "Вернуть на доработку",
      rejectAtModeration: "Отклонить",
      requestAdditionalEvaluation: "Запросить доп. оценку",
      passEvaluation: "Оценка пройдена",
      rejectAtEvaluation: "Отклонить на оценке",
      startTeamFormation: "Начать набор команды",
      complete: "Завершить проект",
      finalizeRound: "Зафиксировать итог раунда",
      criteriaWeightsInvalid:
        "Нельзя зафиксировать раунд: сумма весов активных критериев должна быть равна 100. Текущая сумма: {{sum}}.",
      reasonPlaceholder: "Причина (необязательно)…",
      confirmAction: "Подтвердить действие?",
      noProjects: "Нет проектов для этого этапа",
      createdToday: "создано сегодня",
      createdDaysAgo_one: "создано {{count}} день назад",
      createdDaysAgo_few: "создано {{count}} дня назад",
      createdDaysAgo_many: "создано {{count}} дней назад",
      createdDaysAgo_other: "создано {{count}} дней назад",
      openProject: "Открыть проект",
      actionsTitle: "Действия",
      scoreLine: "Оценка: {{value}}/100",
      scorePrefix: "Оценка:",
      scoreValue: "{{value}}/100",
      evaluationProgress: "Прогресс оценки",
      roundLabelInitial: "Раунд 1",
      roundLabelAdditional: "Раунд 2",
      hints: {
        approveModeration: "проект сразу перейдёт в статус «На экспертной оценке».",
        returnForRevision: "автор увидит причину и сможет отредактировать заявку.",
        finalizeRound: "система проверит сумму весов и зафиксирует итоговый балл раунда.",
        requestAdditionalEvaluation: "проект перейдёт в дополнительный раунд оценки.",
        passEvaluation: "проект будет отмечен как успешно прошедший оценку.",
        startTeamFormation: "после этого можно управлять составом команды.",
        complete: "проект получит статус «Завершён».",
        reject: "проект получит статус «Отклонён» с указанием причины.",
        rejectAtEvaluation: "проект получит статус «Отклонён» с указанием причины",
      },
    },
    evaluation: {
      title: "Экспертная оценка",
      selectProject: "Выберите проект",
      viewProject: "Посмотреть проект",
      viewProjectTooltip: "Открыть карточку проекта в портале: описание, статус и материалы",
      round: "Раунд",
      roundInitial: "Основной",
      roundAdditional: "Дополнительный",
      additionalRoundBlocked:
        "Дополнительную оценку можно провести только по проектам, которые вы полностью оценили в основном раунде.",
      queue: {
        additionalRoundRequiresInitial:
          "В дополнительном раунде отображаются только проекты, которые вы полностью оценили в основном.",
        filterLabel: "Фильтр",
        filterAll: "Все",
        filterEvaluated: "Оценено",
        filterNotEvaluated: "Не оценено",
        evaluated: "Оценено",
        expertScore: "Балл",
        goToEvaluation: "Перейти к оценке",
        criteriaHint: "Активных критериев: {{count}}",
        projectsEvaluatedCount: "Оценено {{evaluated}} из {{total}} проектов",
        allProjectsEvaluated: "Все проекты оценены",
        sortAria: "Сортировать: {{column}}, {{direction}}",
        sortDirectionAsc: "по возрастанию",
        sortDirectionDesc: "по убыванию",
        sortDirectionNone: "без сортировки",
      },
      criteriaTitle: "Критерий",
      score: "Балл",
      comment: "Комментарий",
      submitScores: "Отправить оценки",
      submitting: "Отправляем…",
      submitSuccess: "Оценки отправлены",
      submitError: "Не удалось отправить оценки",
      aggregateScore: "Агрегированный балл",
      aggregateScoreExpert: "Ваш итог по критериям",
      commissionRoundFinalLabel: "Зафиксированный балл раунда (комиссия)",
      finalized: "Раунд зафиксирован",
      notFinalized: "Раунд не зафиксирован",
      yesNoYes: "Да",
      yesNoNo: "Нет",
      scoresLoadError: "Не удалось загрузить оценки",
      projectsLoadError: "Не удалось загрузить проекты для оценки",
      noCriteria: "Для выбранного раунда нет активных критериев",
      scoreProgress: "Заполнено критериев: {{completed}} из {{total}}",
      expertCount: "Экспертов оценило: {{count}}",
      criteriaAveragesTitle: "Средние по критериям",
      criteriaAveragesTitleExpert: "Ваша сводка по критериям",
      criteriaAveragesEmpty: "Пока нет данных от экспертов",
      criteriaAveragesEmptyExpert: "Пока нет данных для сводки",
      criteriaTableCriterion: "Критерий",
      criteriaTableWeight: "Вес",
      criteriaTableScorePoints: "Балл (0–100)",
      breakdownTitle: "Разбивка по экспертам",
      breakdownLoadError: "Не удалось загрузить разбивку по экспертам",
      breakdownEmpty: "Оценок ещё нет",
      breakdownExpert: "Эксперт",
      breakdownTotalScore: "Итоговый балл",
      breakdownColScore: "Балл (0–100)",
      breakdownColWeight: "Вес",
      breakdownColComment: "Комментарий",
      breakdownExpand: "Развернуть",
      breakdownCollapse: "Свернуть",
    },
    criteria: {
      title: "Критерии оценки",
      create: "Добавить критерий",
      editTitle: "Редактирование критерия",
      createFormTitle: "Новый критерий",
      name: "Название",
      description: "Описание",
      type: "Тип",
      typeYesNo: "Бинарная оценка",
      typeNumericScale: "Числовая оценка",
      scaleValues: "Значения шкалы",
      addScaleValue: "Добавить значение",
      removeScaleValue: "Удалить",
      scaleDescriptionPlaceholder: "Описание значения",
      scaleValuesEmptyHint: "Добавьте хотя бы одно значение шкалы",
      scaleValuesEmpty: "Добавьте хотя бы одно значение шкалы",
      scaleValuesMinCount: "Добавьте минимум два значения шкалы",
      scaleValueMustBeInteger: "Значение шкалы должно быть целым числом",
      scaleValueDuplicate: "Значения шкалы не должны дублироваться",
      scaleDescriptionRequired: "Заполните описание для значения {{value}}",
      scaleValuesCount: "Значений: {{count}}",
      minValue: "Минимум",
      maxValue: "Максимум",
      weight: "Вес",
      round: "Раунд",
      active: "Активен",
      sortOrder: "Порядок сортировки",
      save: "Сохранить",
      delete: "Удалить",
      confirmDeleteTitle: "Удалить критерий?",
      confirmDelete: "Удалить критерий?",
      weightsValid: "Сумма весов = 100",
      weightsInvalid: "Сумма весов ≠ 100",
      currentSum: "Текущая сумма",
      weightRemaining: "Доступно веса: {{remaining}}",
      weightExceededRemaining: "Вес превышает доступный остаток. Можно указать не больше {{remaining}}",
      createDisabledRoundFull: "Нельзя добавить критерий: в раунде «{{round}}» сумма весов уже равна 100",
      createDisabledAllRoundsFull: "Нельзя добавить критерий: сумма весов в обоих раундах уже равна 100",
      empty: "Критерии пока не созданы",
      inactive: "неактивен",
      loadError: "Не удалось загрузить критерии",
      saveError: "Не удалось сохранить критерий",
      deleteError: "Не удалось удалить критерий",
    },
    scoreboard: {
      title: "Рейтинговая таблица",
      rank: "№",
      projectTitle: "Проект",
      status: "Статус",
      finalScore: "Итоговый балл",
      round: "Раунд",
      empty: "Нет данных для отображения",
      loadError: "Не удалось загрузить рейтинг",
      moderatorHint:
        "В таблице только проекты, по которым для выбранного раунда уже есть итоговый балл (раунд финализирован). Проекты без финализации раунда или ещё проходящие оценку здесь не отображаются.",
      expertSubsetHint:
        "Это рейтинг проектов, которые вы оценивали в выбранном раунде. В колонке «Итоговый балл» — суммарная оценка проекта после фиксации раунда. Чтобы увидеть свои оценки по критериям и комментарии, раскройте строку проекта.",
      prevPage: "Предыдущая страница",
      nextPage: "Следующая страница",
    },
    evaluationSummary: {
      byExpertsTitle: "Сводка оценки по экспертам",
      byExpertsSubtitle: "Для каждого эксперта — проекты и баллы по критериям в выбранном раунде.",
      byProjectsTitle: "Сводка оценки по проектам",
      byProjectsSubtitle: "Для каждого проекта — эксперты и баллы по критериям в выбранном раунде.",
      filterProjectSearchPlaceholder: "Поиск по названию проекта",
      filterProjectSearchAria: "Поиск по названию проекта в сводке оценки",
      filterExpertSearchPlaceholder: "Поиск по имени эксперта",
      filterExpertSearchAria: "Поиск по имени эксперта в сводке оценки",
      loadError: "Не удалось загрузить сводку",
      empty: "Нет данных для отображения",
      projectsUnderExpert: "Проекты",
      expertsUnderProject: "Эксперты",
      projectTotalScore: "Балл по проекту",
    },
    team: {
      title: "Управление командой",
      subtitle:
        "Проекты на этапах модерации, оценки и формирования команды. Выберите проект и управляйте составом.",
      selectProjectHint: "Выберите проект в списке слева, чтобы просмотреть и изменить команду.",
      noTeamProjects: "Нет проектов на выбранном этапе",
      noTeamProjectsCta: "Перейти к модерации",
      projectListAria: "Список проектов для формирования команды",
      projectSearchPlaceholder: "Поиск по названию или описанию…",
      memberSearch: "Участник",
      addMemberTitle: "Добавить участника",
      editMemberTitle: "Редактировать участника",
      addMemberStatusHint: "Участник будет добавлен со статусом «Приглашён».",
      openProject: "Открыть карточку проекта",
      roleEmpty: "—",
      authorRole: "Автор",
      actionsColumn: "Действия",
      membersListAria: "Список участников команды",
      summaryAria: "Сводка по статусам участников",
      summaryInvited: "Приглашены: {{count}}",
      summaryAccepted: "Приняли: {{count}}",
      summaryDeclined: "Отклонили: {{count}}",
      summaryTotal: "Всего: {{count}}",
      invitationsSectionTitle: "Приглашения в команду",
      invitationsSectionLead:
        "Здесь отображаются приглашения в проекты, в которых вас добавили как участника. Принять или отклонить можно, пока приглашение остаётся активным.",
      invitationsEmpty: "Сейчас нет активных приглашений в команду.",
      invitationsLoadError: "Не удалось загрузить список приглашений.",
      invitationActionError: "Не удалось выполнить действие. Возможно, приглашение уже недействительно.",
      invitationUntitledProject: "Проект без названия",
      acceptInvitation: "Принять",
      declineInvitation: "Отклонить",
      acceptInvitationAria: "Принять приглашение в команду проекта «{{title}}»",
      declineInvitationAria: "Отклонить приглашение в команду проекта «{{title}}»",
      invitationsListAria: "Список приглашений в команду проектов",
      invitationProjectHint: "После принятия вы станете участником команды этого проекта.",
      invitationAcceptedHint: "Приглашение принято. Проект появится в разделе «Мои проекты» → «Проекты, где я в команде».",
      viewProject: "Посмотреть проект",
      viewProjectAria: "Посмотреть карточку проекта «{{title}}»",
      viewProjectTooltip: "Открыть описание, статус и материалы проекта",
      selectProject: "Выберите проект",
      addMember: "Добавить участника",
      userId: "ID пользователя",
      userLookupPlaceholder: "Начните вводить ФИО, логин или email",
      userLookupMinChars: "Введите минимум 2 символа для поиска",
      userLookupNoResults: "Пользователи не найдены",
      role: "Роль",
      rolePlaceholder: "Роль в команде",
      status: "Статус",
      statusInvited: "Приглашён",
      statusAccepted: "Принят",
      statusDeclined: "Отклонён",
      save: "Сохранить",
      remove: "Удалить",
      editMemberAria: "Редактировать участника: {{name}}",
      removeMemberAria: "Удалить участника {{name}} из команды",
      confirmRemoveTitle: "Удалить участника?",
      confirmRemove: "Удалить участника из команды?",
      noMembers: "В команде пока нет участников",
      projectsLoadError: "Не удалось загрузить проекты для формирования команд",
      loadError: "Не удалось загрузить команду",
      saveError: "Не удалось сохранить",
      removeError: "Не удалось удалить участника",
    },
  },
}
